import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "data-set_32",
  "use": "data-set_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"data-set_32\"><path d=\"M25 13V4h-2v2h-3v2h3v5h-3v2h8v-2h-3zM8.5 6A3.5 3.5 0 115 9.5 3.5 3.5 0 018.5 6m0-2A5.5 5.5 0 1014 9.5 5.5 5.5 0 008.5 4zm0 16A3.5 3.5 0 115 23.5 3.5 3.5 0 018.5 20m0-2a5.5 5.5 0 105.5 5.5A5.5 5.5 0 008.5 18zm15 2a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5m0-2a5.5 5.5 0 105.5 5.5 5.5 5.5 0 00-5.5-5.5z\" /><path style=\"fill:none\" d=\"M0 0h32v32H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol